import React from 'react';

import {
  ArrayField,
  AutocompleteArrayInput,
  ChipField,
  Count,
  Datagrid,
  Filter,
  FunctionField,
  Show,
  ShowButton,
  SimpleShowLayout,
  SingleFieldList,
  TextField,
} from 'react-admin';

import { ContentBasicsFragment } from '../../graphql/types';
import { getDurationSince, parseZdt } from '../../utils/date';
import { IDSearch } from '../reusable/IDSearch';
import ClipboardField from './components/ClipboardField';
import InfiniteList from './components/InfiniteList';

export const contentComponents = [
  'view-ondemand-class',
  'view-ondemand-audio-class',
  'view-ondemand-article',
  'view-section',
  'view-video',
  'view-audio',
  'view-article',
  'view-link',
  'view-banner',
  'view-practice',
  'in-app-survey',
  'view-practice-program',
  'view-program',
  'view-click-through-media',
];

const ContentTitle = () => (
  <>
    Content: <Count />
  </>
);

const ContentFilter: React.FC = (props) => (
  <Filter {...props}>
    <IDSearch label="Name" source="search" alwaysOn />
    <AutocompleteArrayInput
      sx={{ width: '250px' }}
      source="__typename"
      label="Component"
      choices={contentComponents.map((name) => ({
        id: name,
        name: name,
      }))}
    />
  </Filter>
);

export const ContentList: React.FC = () => {
  return (
    <InfiniteList
      filters={<ContentFilter />}
      title={<ContentTitle />}
      sort={{ field: 'lastPublishedAt', order: 'DESC' }}
    >
      <Datagrid rowClick={false} bulkActionButtons={false}>
        <ClipboardField source="id" sortable={false} />
        <TextField
          source="__typename"
          label="Type"
          sortable={false}
          emptyText="-"
        />
        <TextField source="title" sortable={true} emptyText="-" />
        <FunctionField<ContentBasicsFragment>
          source="lastPublishedAt"
          sortable={true}
          label="Published"
          render={(record) =>
            `${getDurationSince(parseZdt(record.lastPublishedAt))}`
          }
        />
        <TextField
          source="contentGenre.name"
          label="Genre"
          sortable={false}
          emptyText="-"
        />
        <ShowButton />
      </Datagrid>
    </InfiniteList>
  );
};

export const ContentShow: React.FC = () => (
  <Show>
    <SimpleShowLayout>
      <ClipboardField source="id" fontSize={14} />
      <ClipboardField source="title" fontSize={14} />
      <TextField source="__typename" label="Type" emptyText="-" />
      <TextField source="author" emptyText="-" />
      <FunctionField<ContentBasicsFragment>
        source="lastPublishedAt"
        label="Published"
        render={(record) =>
          `${record.lastPublishedAt} / ${getDurationSince(parseZdt(record.lastPublishedAt))}`
        }
      />
      <TextField source="contentTime.name" label="Time" emptyText="-" />
      <TextField source="contentGenre.name" label="Genre" emptyText="-" />
      <TextField source="contentSplit.name" label="Split" emptyText="-" />
      <TextField source="contentLevel.name" label="Level" emptyText="-" />
      <ArrayField source="contentEquipment" label="Equipment" emptyText="-">
        <SingleFieldList linkType={false}>
          <ChipField source="name" size="small" />
        </SingleFieldList>
      </ArrayField>
    </SimpleShowLayout>
  </Show>
);
